import { Component } from '@angular/core';

@Component({
    selector: 'upp-application-main',
    templateUrl: './upp-main.html',
    styleUrls: ['./upp-main.scss'],
})
export class UppApplicationMainComponent {
    // nothing to do
}
